module.exports = __webpack_public_path__ + "media/newstyle/images/stars_2-red-4da91050254a3a85f057f449eeb5f504.svg";